// extracted by mini-css-extract-plugin
module.exports = {"box":"_1AkXhfMjWwPqzw0lQp2uNL"};